export const SITE_URL = 'https://www.nammanesavunool.in';

export const SITE_NAME = 'Namma Nesavu Nool';

export const SITE_TAGLINE = 'Tradition Meets Trend';

export const DEFAULT_TITLE =
    'Namma Nesavu Nool | Handloom Sarees, School Uniforms & Custom Textiles';

export const DEFAULT_DESCRIPTION =
    'Shop handwoven sarees, school uniform set dresses, mundu, dhothi, and custom textiles from Namma Nesavu Nool in Erode, Tamil Nadu. Bulk orders and custom weaving welcome.';

export const DEFAULT_KEYWORDS = [
    'Namma Nesavu Nool',
    'handloom sarees',
    'school uniforms',
    'school uniform sets',
    'custom textiles',
    'handwoven fabrics',
    'mundu',
    'dhothi',
    'bulk uniform orders',
    'Erode textiles',
    'Tamil Nadu handloom',
    'traditional weaving',
    'custom design fabrics',
].join(', ');

export const BUSINESS = {
    phone: '+919655007980',
    phoneDisplay: '+91 9655007980',
    email: 'nammanesavunool@gmail.com',
    streetAddress: 'Erode',
    addressLocality: 'Erode',
    addressRegion: 'Tamil Nadu',
    postalCode: '638056',
    addressCountry: 'IN',
    instagram: 'https://www.instagram.com/nammanesavunool/',
    geo: {
        latitude: 11.3410,
        longitude: 77.7172,
    },
};

export const OG_IMAGE = `${SITE_URL}/NNN-logo.png`;
